export default __webpack_public_path__ + "static/Soundly-6f46a71cce49cb7ac3a358756a10f870.webp";